/* VANA Geschenkverpackung auf der Produktseite – ausgelagert 12.10.2026 aus snippets/vana-pdp-giftwrap.liquid. Varianten-ID kommt aus data-variant-id. */
(function () {
  var __vpgEl = document.querySelector('[data-vana-pdp-gift][data-variant-id]');
  var VARIANT_ID = __vpgEl ? parseInt(__vpgEl.getAttribute('data-variant-id'), 10) : null;
  if (!VARIANT_ID) return;
  var TEXT = 'Wir verpacken - du überreichst';
  var pdpBusy = false;

  var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';

  function blocks() {
    return document.querySelectorAll('[data-vana-pdp-gift]');
  }

  function setState(state) {
    // state: 'off' | 'on' | 'in_cart'
    blocks().forEach(function (block) {
      var input = block.querySelector('[data-vana-pdp-gift-toggle]');
      var text = block.querySelector('[data-vana-pdp-gift-text]');
      var checked = state !== 'off';
      input.checked = checked;
      input.disabled = false;
      block.classList.toggle('is-checked', checked);
      block.classList.remove('is-locked');
      block.setAttribute('data-state', state);
      if (text) text.textContent = TEXT;
    });
  }

  function currentState() {
    var block = document.querySelector('[data-vana-pdp-gift]');
    return block ? block.getAttribute('data-state') || 'off' : 'off';
  }

  function syncWithCart() {
    return fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var inCart = (cart.items || []).some(function (item) {
          return Number(item.variant_id) === VARIANT_ID;
        });
        if (pdpBusy) return;
        if (inCart) {
          setState('in_cart');
        } else if (currentState() === 'in_cart') {
          setState('off');
        }
      })
      .catch(function () {});
  }

  if (!window.__VANA_PDP_GIFT__) {
    window.__VANA_PDP_GIFT__ = true;

    function removeGiftFromCart() {
      pdpBusy = true;
      return fetch(root + 'cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var line = (cart.items || []).filter(function (item) {
            return Number(item.variant_id) === VARIANT_ID;
          })[0];
          if (!line) return null;
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 }),
          }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          if (cart) {
            document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
          }
        })
        .catch(function () {})
        .finally(function () {
          pdpBusy = false;
          syncWithCart();
        });
    }

    function toggleGift(checked) {
      if (checked) {
        // Vormerken: kommt beim nächsten "In den Warenkorb" mit
        setState('on');
        return;
      }
      var wasInCart = currentState() === 'in_cart';
      setState('off');
      if (wasInCart) removeGiftFromCart();
    }

    // Häkchen
    document.addEventListener('change', function (event) {
      var input = event.target && event.target.closest && event.target.closest('[data-vana-pdp-gift-toggle]');
      if (!input) return;
      toggleGift(input.checked);
    });

    // Klick auf Text = Häkchen umschalten
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var opener = target.closest('[data-vana-pdp-gift-open]');
      if (opener) {
        event.preventDefault();
        var block = opener.closest('[data-vana-pdp-gift]');
        var panel = block.querySelector('[data-vana-pdp-gift-panel]');
        var open = panel.hasAttribute('hidden');
        if (open) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
        block.classList.toggle('is-open', open);
        block.querySelectorAll('.vana-pdp-gift__chevron').forEach(function (b) {
          b.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        return;
      }

      var content = target.closest('.vana-pdp-gift__content');
      if (content) {
        event.preventDefault();
        var input = content.closest('[data-vana-pdp-gift]').querySelector('[data-vana-pdp-gift-toggle]');
        toggleGift(!input.checked);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      var opener = event.target && event.target.closest && event.target.closest('[data-vana-pdp-gift-open]');
      if (!opener) return;
      event.preventDefault();
      opener.click();
    });

    // Geschenkverpackung nach erfolgreichem "In den Warenkorb" hinzufügen
    function addGiftAfterProduct() {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] }),
      })
        .then(function () {
          return fetch(root + 'cart.js', { credentials: 'same-origin' }).then(function (r) {
            return r.json();
          });
        })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        })
        .catch(function () {
          setState('on');
        });
    }

    // Das Theme legt Artikel per XMLHttpRequest (axios) in den Warenkorb
    var xhrOpen = XMLHttpRequest.prototype.open;
    var xhrSend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__vanaGiftUrl = String(url || '');
      this.__vanaGiftMethod = String(method || '').toUpperCase();
      return xhrOpen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (body) {
      try {
        var isAdd = this.__vanaGiftMethod === 'POST' && /\/cart\/add(\.js)?(\?|$)/.test(this.__vanaGiftUrl);
        var bodyText = typeof body === 'string' ? body : '';
        if (isAdd && currentState() === 'on' && bodyText.indexOf(String(VARIANT_ID)) === -1) {
          setState('in_cart');
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) {
              addGiftAfterProduct();
            } else {
              setState('on');
            }
          });
        }
      } catch (error) {}
      return xhrSend.apply(this, arguments);
    };

    // Falls irgendwo per fetch hinzugefügt wird (z. B. andere Buttons)
    var originalFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

      if (!isAdd || currentState() !== 'on') {
        return originalFetch.apply(this, arguments);
      }

      // Nicht doppelt auslösen, wenn gerade die Verpackung selbst hinzugefügt wird
      var bodyText = init && typeof init.body === 'string' ? init.body : '';
      if (bodyText.indexOf(String(VARIANT_ID)) !== -1) {
        return originalFetch.apply(this, arguments);
      }

      var self = this;
      var args = arguments;
      setState('in_cart');

      return originalFetch.apply(self, args).then(function (response) {
        if (!response.ok) {
          setState('on');
          return response;
        }
        addGiftAfterProduct();
        return response;
      });
    };

    var syncTimer = null;
    function scheduleSync(delay) {
      window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncWithCart, delay || 350);
    }

    document.addEventListener('theme:cart:change', function () {
      scheduleSync(400);
    });

    function observeDrawer() {
      document.querySelectorAll('#drawer-cart [data-line-items]').forEach(function (el) {
        if (el.__vanaPdpGiftObserved) return;
        el.__vanaPdpGiftObserved = true;
        new MutationObserver(function () {
          scheduleSync(350);
        }).observe(el, { childList: true });
      });
    }

    observeDrawer();
    document.addEventListener('DOMContentLoaded', observeDrawer);
    window.addEventListener('pageshow', function () {
      scheduleSync(50);
    });
  }

  setState('off');
  syncWithCart();
})();
